const awsmobile = {
   "aws_project_region": "us-east-2",
   "aws_cognito_identity_pool_id": "us-east-2:dc738c6b-0b94-49eb-9692-00e0f7efeba9",
   "aws_cognito_region": "us-east-2",
   "aws_user_pools_id": "us-east-2_vtSyFarm8",
   "aws_user_pools_web_client_id": "7j1503q96p2n8l08vlq7ervaff"
}
export default awsmobile;
